<template>
  <div class="text-standard">
    <div class="laptop:min-660 xl:min-660 tablet:min-660 md: h-64 min-h-full form bg-cover bg-center" />

    <div class="laptop:mt-16 laptop:container mx-auto w-full relative min-660">
      <div class="w-full flex flex-wrap md:mx-3 md: mt-8 laptop:mx-0">
        <div class="laptop:w-6/12 px-5 pb-16 lg:pr-8 laptop:px-12 lg:w-1/2 w-full">
          <div class="laptop:pl-16 flex content-center mt-4 md:mt-0">
            <img loading="lazy" class="mr-1" src="~/assets/img/examples/4-stelle.svg">
            <div class="flex flex-col justify-center h-8 align-middle pl-4 text-xs">
              (207 ratings)
            </div>
          </div>
          <h2 class="text-formred laptop:pl-16 laptop:text-55xl md:text-5xl">
            Form Armchair
          </h2>
          <h2 class="color: formgray laptop:pl-16 laptop:text-45xl md:text-3xl">
            € 00,00
          </h2>
        </div>
        <div class="md: flex flex-col laptop:mt-0 md: px-5 laptop:pr-28 laptop:pl-12 lg:w-1/2 w-full">
          <div class="laptop:flex flex-wrap justify-items-start justify-start mr-2 mb-6">
            <img loading="lazy" src="~/assets/img/share.svg">
          </div>
          <p>
            This is an example of integration of 3D contents inside a website.
            <br>
            It is intended to suggest ideas of applications on e-commerce and
            info-commerce of the outputs of My AR Studio. <br>
          </p>
          <p>For further information see <a class="text-orange underline" target="_blank" href="/learn/documentation/distribute/universal-viewer/">our documentation</a></p>
        </div>
      </div>

      <div class="container mx-auto flex flex-col md:flex-row pt-10">
        <div class="laptop:w-6/12 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0">
          <iframe v-if="colors == 'Bordeaux'" class="h-fiftyvh md:h-full lg:h-full" style="width: 100%"
                  allow="xr-spatial-tracking *;"
                  :src="'https://viewer.myarstudio.cloud/viewer_master/index.html?p=761392f8-c509-5112-8595-9ee91cd01690&c=59aec7f4-2b89-547c-9710-823436af4c9a&b=f2f01834-6984-4e4d-bd20-8e7586523cf0&language=' + $i18n.locale" />
          <iframe v-else-if="colors == 'Grigia'" class="h-fiftyvh md:h-full lg:h-full" style="width: 100%"
                  allow="xr-spatial-tracking *;"
                  :src="'https://viewer.myarstudio.cloud/viewer_master/index.html?p=761392f8-c509-5112-8595-9ee91cd01690&c=5ecd5f37-2782-591d-a681-68ce15b8b058&b=f2f01834-6984-4e4d-bd20-8e7586523cf0&language=' + $i18n.locale" />
          <iframe v-else-if="colors == 'Nera'" class="h-fiftyvh md:h-full lg:h-full" style="width: 100%"
                  allow="xr-spatial-tracking *;"
                  :src="'https://viewer.myarstudio.cloud/viewer_master/index.html?p=761392f8-c509-5112-8595-9ee91cd01690&c=ea180254-66d1-586e-9c71-8760eb5b7e24&b=f2f01834-6984-4e4d-bd20-8e7586523cf0&language=' + $i18n.locale" />
        </div>

        <div class="laptop: md:w-6/12 px-5 mt-6 laptop:pr-28 laptop:pl-0 lg:w-1/2 w-full">
          <div class="mb-5">
            <div class="pb-2">
              <p>Shell material*</p>
            </div>

            <div class="h-30">
              <form>
                <select class="laptop:w-80 md: w-full h-10 pl-2 bg-formgray">
                  <option>Plastic</option>
                </select>
              </form>
            </div>
          </div>

          <div class="mb-5">
            <div class="pb-2">
              <p>Color*</p>
            </div>

            <div class="h-30">
              <form>
                <select id="colors" v-model="colors" name="Bordeaux" class="laptop:w-80 md: w-full h-10 pl-2 bg-formgray">
                  <option>Bordeaux</option>
                  <option>Grigia</option>
                  <option>Nera</option>
                </select>
              </form>
            </div>
          </div>

          <div class="pb-2">
            <p>Qty*</p>
          </div>

          <div class="qty-container mb-20 flex laptop:w-80 md: w-full md:justify-start justify-between">
            <div class="bg-formgray laptop:text-sm md: text-xl w-32 md:w-full h-auto flex justify-between items-center">
              <button class="laptop:h-8 md: h-20" @click="currentQty++">
                +
              </button>
              <div class="h-8 pt-1 align-middle">{{ currentQty }}</div>
              <button class="h-8" @click="currentQty--">-</button>
            </div>
            <button class="ml-6 w-96 laptop:text-sm text-white text-left md: text-xl bg-formred">
              Add to cart
            </button>
          </div>

          <p>
            Form is a modern armchair with a minimalistic expression designed by
            Simon Legald. With its simple and contemporary design Form Armchair
            has a soft and welcoming silhouette and a distinctly residential
            look. Combined with a clean design, that makes Form a flexible and
            functional chair for any room.
            <br>
            <br>
          </p>
          <p>
            All the information and images in this page come from
            normann-cpenhagen.com and dimensiva.com.
          </p>
        </div>
      </div>

      <!-- <div class="w-full flex flex-wrap md: ml-5 laptop:mx-0">
        <div class="laptop:w-6/12 laptop:px-5   lg:w-1/2 w-full">
          <div class="flex flex-wrap">
            <img loading="lazy" class=" laptop:w-1/5 pt-5 md: pr-5 md: w-1/4" src="~/assets/img/renders/3.webp"/>
            <img loading="lazy" class=" laptop:w-1/5 pt-5 md: pr-5 md: w-1/4" src="~/assets/img/renders/3.webp"/>
            <img loading="lazy" class=" laptop:w-1/5 pt-5 md: pr-5 md: w-1/4" src="~/assets/img/renders/3.webp"/>
            <img loading="lazy" class=" laptop:w-1/5 pt-5 md: pr-5 md: w-1/4" src="~/assets/img/renders/3.webp"/>

          </div>

        </div>

      </div>
       -->

      <div class="mt-20 w-full flex flex-wrap laptop:mx-0">
        <div class="laptop:w-6/12 px-5 lg:w-1/2 w-full">
          <p class="laptop:pl-16 mobile: mt-20 laptop:mr-5">
            <b>Specifications</b><br>Product information: Form is delivered
            assembled. The plastic type is Polypropylene (PP). Armchair armrest
            height: 65,8 cm<br><br><b>Maintenance:</b><br>Clean with damp
            cloth.
          </p>
        </div>
        <div class="grid gap-y-4 auto-rows-auto laptop:pr-20 laptop:pl-12 laptop:w-6/12 mobile: mt-20 px-5 lg:w-1/2 w-full">
          <div class="pl-2 grid gap-3 grid-cols-2">
            <div class="font-bold">Model</div>
            <div>Form Armchair</div>
          </div>

          <hr style="width: 95%">

          <div class="pl-2 grid gap-4 grid-cols-2">
            <div class="font-bold">Designer</div>
            <div>
              <nobr>Simon Legald</nobr>
            </div>
          </div>

          <hr style="width: 95%">

          <div class="pl-2 grid gap-4 grid-cols-2">
            <div class="font-bold">Colour</div>
            <div>Bordeaux</div>
          </div>

          <hr style="width: 95%">

          <div class="pl-2 grid gap-4 grid-cols-2">
            <div class="font-bold">Material</div>
            <div>Shell: plastic,Legs:oak</div>
          </div>

          <hr style="width: 95%">

          <div class="pl-2 grid gap-4 grid-cols-2">
            <div class="font-bold">Product weight</div>
            <div>5,3 kg</div>
          </div>

          <hr style="width: 95%">

          <div class="pl-2 grid gap-4 grid-cols-2">
            <div class="font-bold">Product size</div>
            <div class="laptop:break-normal overflow-wrap:normal md:break-normal overflow-wrap:break-word">
              H: 80 X L: 56 X D: 52 x SH: 44 cm
            </div>
          </div>

          <hr style="width: 95%">
        </div>
      </div>

      <div class="w-full mt-32 md: px-5 laptop:mt-150px">
        <img loading="lazy" alt="Form armchair" class="laptop:mx-auto mt-24" src="~/assets/img/examples/form-tavolo.webp">
      </div>

      <div class="flex flex-row md: px-5 pt-5">
        <div class="w-5/12 pr-2.5">
          <img loading="lazy" alt="Form armchair" class="mx-auto" src="~/assets/img/examples/form-sedie-colorate.webp">
        </div>
        <div class="w-7/12 pl-2.5">
          <img loading="lazy" alt="Form armchair" class="mx-auto" src="~/assets/img/examples/form-sedie-rosa.webp">
        </div>
      </div>

      <div class="mt-32 md: mx-5 xl:mx-40">
        <h3 class="text-formred font-bold text-2xl xl:text-4xl">
          Customer reviews
        </h3>
        <div class="mt-8 md:mt-12 xl:mt-90px">
          <div class="w-full md:w-1/3 flex h-20 mb-8">
            <div class="flex flex-col justify-between">
              <div class="flex content-center pb-4">
                <img loading="lazy" class="px-1 pl-0" src="~/assets/img/examples/4-stelle.svg">
              </div>

              <p class="pb-2">Customer Name - June 25,2020</p>
            </div>
          </div>

          <div class="w-full flex flex-col mb-12">
            <b>Title of the review</b>
            <p>
              At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque corrupti quos
              dolores et quas molestias excepturi sint occaecati cupiditate non
              provident.
            </p>
          </div>
        </div>
        <div class="mt-8 md:mt-12 xl:mt-90px">
          <div class="w-full md:w-1/3 flex h-20 mb-8">
            <div class="flex flex-col justify-between">
              <div class="flex content-center pb-4">
                <img loading="lazy" class="px-1 pl-0" src="~/assets/img/examples/5-stelle.svg">
              </div>

              <p class="pb-2">Customer Name - June 25,2020</p>
            </div>
          </div>

          <div class="w-full flex flex-col mb-12">
            <b>Title of the review</b>
            <p>
              At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium voluptatum deleniti atque corrupti quos
              dolores et quas molestias excepturi sint occaecati cupiditate non
              provident.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="laptop:mx-24">
      <div class="container mx-auto mt-32 laptop:mt-0" style="max-width: 1280px;">
        <div style="position: relative; width: 100%; padding-top: 56.22%;">
          <div class="w-full h-full absolute top-0">
            <iframe v-if="youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/ZISQ1LHhsAU?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <iframe v-if="!youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/ZISQ1LHhsAU?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <iframe v-if="youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/zoYL91VlvGo?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <iframe v-if="!youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/zoYL91VlvGo?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div> -->
    <TryIt class="md: px-0" />
    <div class="hidden md:block">
      <img loading="lazy" alt="Form schema" class="mx-auto" src="~/assets/img/examples/form-schema.webp">
    </div>
  </div>
</template>

<script lang="ts">
import TryIt from '@/components/TryIt.vue'

export default defineNuxtComponent({
  components: {
    TryIt,
  },

  data: function () {
    return {
      currentQty: 1,
      colors: 'Bordeaux',
    }
  },
})
</script>

<style scoped>
.form {
  background-image: url("~/assets/img/examples/form-hero.webp")
}
</style>
